import { type FilterValue } from "antd/lib/table/interface";

export const filtersToQueryString = (
  filters: Record<string, FilterValue | null>,
): string => {
  let filterString = "";
  for (const [key, value] of Object.entries(filters)) {
    if (value == null) {
      continue;
    }
    if (filterString !== "") {
      filterString += "-";
    }
    filterString += `${key}*${String(value)}`;
  }
  return filterString;
};
